import { ar } from './ar.js';
import { bn } from './bn.js';
import { es } from './es.js';
import { fa } from './fa.js';
import { fr } from './fr.js';
import { gu } from './gu.js';
import { it } from './it.js';
import { pa } from './pa.js';
import { pl } from './pl.js';
import { pt } from './pt.js';
import { ro } from './ro.js';
import { so } from './so.js';
import { tl } from './tl.js';
import { tr } from './tr.js';
import { ur } from './ur.js';
import { zh } from './zh.js';

export const translations = Object.freeze({ ar, bn, es, fa, fr, gu, it, pa, pl, pt, ro, so, tl, tr, ur, zh });
